import { Col, Container, Row } from "reactstrap";

const Benefit = () => {

  const listBenefits = [
    { title:"Skill yang Dicari Industri", body:"Belajar langsung dengan pendekatan kerja nyata biar CV kamu stand out pas apply kerja." },
    { title:"Visa Pelajar = Kerja Paruh Waktu", body:"Biasanya visa pelajar di Australia ngasih kamu hak kerja part-time saat semester untuk bantu biaya hidup." },
    { title:"Pengalaman Hidup Internasional", body:"Hidup di Melbourne bukan cuma belajar — kamu bakal eksplor budaya, travel sekitar Australia, dan bangun jaringan global." },
    { title:"Jalur Ke Pendidikan Lanjut", body:"Keluar dari diploma atau associate bisa jadi pathway masuk ke universitas lain di Australia." },
  ]

  return (
    <section className="section benefit-wrapper" id="benefit">
      <Container>
        <Row>
          <Col xs='12' md='7' className="benefit-items">
            <h1><b>Benefit Kuliah di Melbourne Polytechnic</b></h1>
              <ol>
                {listBenefits.map((item, id) => (
                  <li key={id}>
                    {item.title}
                    <p className="fw-normal">{item.body}</p>
                  </li>
                ))}
              </ol>
          </Col>    
          <Col xs='12' md='5' className='benefit-bg'>
            <img 
              src="assets/images/benefit-bg.webp" 
              alt="student-searching-benefits-study-at-melbourne-poly" 
              className="img-fluid"
            />
          </Col>        
        </Row>
      </Container>
    </section>
  );
};

export default Benefit;